import { useMsal } from "@azure/msal-react";
import { useFeedback } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { useNavigate } from "@opendash/router";
import { Button } from "antd";
import Parse from "parse";
import React from "react";
import { loginRequest } from "./msalConfig";

export const MicrosoftLoginButton: React.FC = () => {
  const nav = useNavigate();
  const t = useTranslation();
  const { instance } = useMsal();
  const { message } = useFeedback();

  const handleLogin = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest);
      const account = loginResponse.account;

      if (!account) return;

      const accessToken = account.idToken;

      const result = await Parse.Cloud.run("openinc-auth-login-microsoft", {
        token: accessToken,
        account: account,
      });

      if (result) {
        message.success(t("parse-admin:general.login.microsoft.success"));
        await Parse.User.become(result);
        await nav(`/`);
        window.location.reload();
      } else {
        message.error(t("parse-admin:general.login.microsoft.error"));
      }
    } catch (error) {
      console.error(error);
      message.error(t("parse-admin:general.login.microsoft.error"));
    }
  };

  return (
    <Button onClick={handleLogin}>
      {t("parse-admin:general.login.microsoft.label")}
    </Button>
  );
};
